export default __webpack_public_path__ + "static/media/unfullscreen.b5ed1e34.svg";